/* eslint-disable no-script-url */

import React, { useState, useEffect, useContext } from 'react'
import ConfigContext from '../../ConfigContext'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import { Grid, Box } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  gridRoot: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  img: {
    width: '100%',
    objectFit: 'contain',
    cursor: 'pointer'
  },
  isSelected: {
    border: '3px solid #698CC2',
    backgroundColor: '#EFF4FA'
  }
}))

const ImagePicker: React.FC<{
  options: string[]
  // s3対応
  // options: { preview: string; key: string }[]
  initValue: string
  gridSize?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
  pickHandler: (picked: string) => void
}> = ({ options, initValue, gridSize = 2, gridSpacing = 3, pickHandler }) => {
  const classes = useStyles({})
  const [picked, setPicked] = useState(-1)
  const config = useContext(ConfigContext)

  useEffect(() => {
    options.forEach((option, index) => {
      if (option === initValue) {
        // s3対応
        // if (option.key === initValue) {
        setPicked(index)
      }
    })
  }, [options, initValue])

  const handleSelect = (event: React.MouseEvent<HTMLImageElement, MouseEvent>, index: number) => {
    setPicked(index)
    pickHandler(options[index])
    // s3対応
    // pickHandler(options[index].key)
  }

  return (
    <React.Fragment>
      <Grid container alignItems="center" spacing={gridSpacing} className={classes.gridRoot}>
        {options.map((img, index) => (
          <Grid item key={`reg-image-picker-${index}`}>
            <Box
              className={clsx(picked === index && classes.isSelected)}
              width="100px"
              height="100px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <img
                className={classes.img}
                src={`${config.serverHost}${img}`}
                alt={img}
                // s3対応
                // src={img.preview}
                // alt={img.key}
                onClick={(event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
                  handleSelect(event, index)
                }}
              ></img>
            </Box>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  )
}

export default ImagePicker
